module.exports = __webpack_public_path__ + "static/media/homePageImgFace-01.e1689cd0.jpg";